import { useTitle } from 'react-use'

export const usePageTitle = (title: string) => {
  const postfix = 'Sitoo'

  useTitle(`${title} - ${postfix}`)
}
